module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0130.jpg?v=84f5c6ad";